import fetchInstance from "./fetchConfig";
import utils from '../utils/utils'

const eos = {
    async getEosConfigList(venueId, date) {
        const res = await fetchInstance(`/api/venue/v1/venues/${venueId}/shift-configs?date=${date}`)
        const data = await res.json()

        if (res.ok) {
            return data
        } else {
            utils.alert('', data.message, 'error')
        }
    },
    async getEosShifts(venueId, date) {
        const res = await fetchInstance(`/api/venue/v1/venues/${venueId}/shifts?date=${date}`)
        const data = await res.json()

        if (res.ok) {
            return data
        } else {
            if (data.message) {
                utils.alert('', data.message, 'error')
            } else {
                utils.alert('', 'Something went wrong, Please try again later', 'error')
            }
        }

    },
    async saveEosConfig(venueId, date, payloads) {

        const res = await fetchInstance(`/api/venue/v1/venues/${venueId}/shifts?date=${date}`, {
            method: 'PUT',
            body: JSON.stringify(payloads)
        })

        if (res.ok) {
            utils.alert('', 'Eos config saved successfully', 'success')
        } else {
            utils.alert('', 'Something went wrong, Please try again later', 'error')
        }
    
    },

    async deleteEosConfig(venueId, date) {
        const res = await fetchInstance(`/api/venue/v1/venues/${venueId}/shifts?date=${date}`, {
            method: 'DELETE'
        })

        if (res.ok) {
            utils.alert('', 'Eos config deleted successfully', 'success')
        } else {
            utils.alert('', 'Something went wrong, Please try again later', 'error')
        }
    }
}

export default eos;


// WEBPACK FOOTER //
// ./src/api/eos.js